import React from "react";
import { Helmet } from "react-helmet-async";

import "assets/css/components/technology/_index.scss";
import "assets/css/components/landing-refresh/_index.scss";

import {
  Hero,
  InfoGraph,
  HeadingSection,
  Carousel,
  MilaShowcaseCarousel,
} from "../components/technology";
import MilaFeeds from "../components/landing-refresh/MilaFeeds";
import AirInsights from "../components/landing-refresh/AirInsights";
import { airInsightsStatic } from "../static-data/LandingRefresh/airInsightsStatic";
import { graphStatic } from "../static-data/technology/graphStatic";
import { carouselStatic } from "../static-data/technology/carousel";

/**
 * @param {Object} props
 * @return {JSX.Element}
 * @constructor
 */

const Technology = ({ route }) => {
  return (
    <>
      <Helmet>
        <title>{route?.meta?.title}</title>
        <meta name="title" content={route?.meta?.title} />
        <meta name="description" content={route?.meta?.description} />
      </Helmet>
      <Hero />
      <AirInsights
        className="air-insights--technology"
        data={airInsightsStatic}
        title="Mila doesn’t just clean your air. She shows you what’s in it."
      />
      <InfoGraph graphs={graphStatic} />
      {/* <HeadingSection
        title={
          "It’s no wonder 86% of customers say <br /> they know more about their air quality within the first seven days."
        }
      /> */}
      <HeadingSection
        title={"Mila is more than metrics— <br /> she’s thoughtful, too."}
        className="heading-section--secondary"
      />
      {/* <Carousel carouselData={carouselStatic} /> */}
      <MilaShowcaseCarousel />
      <HeadingSection
        title={`<span>
           🏆<br><em>It’s no wonder Mila was a <strong>2024 Webby Award Nominee</strong> for Best Connected Product.</em>
          </span>`}
      />
      <MilaFeeds />
    </>
  );
};

export default Technology;
